import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { SettingsScreen } from './screens/Settings'

/**
 * Settings route — mounted inside album/routes.tsx's `AlbumDesignRoot`
 * (auth + DS provider), reusing the same app shell as /albums and
 * /galleries so the product's chrome stays consistent.
 *
 * /settings
 */
export const settingsRouteElements = (
  <Route path='settings' element={<AlbumShellLayout />}>
    <Route index element={<SettingsScreen />} />
  </Route>
)
